import { createSelector } from 'reselect';

import { getProgramsCategory } from './programsCategory.selectors';

export const selectLlpaCapSchema = createSelector(
  getProgramsCategory,
  ({ llpaCapSchema }) => llpaCapSchema,
);
